<template>
  <div class="inventory-summary-page">
    <h2>📦 Total Inventory Valuation</h2>

    <div class="total-worth-box">
      Total Inventory Worth: <strong>Ksh.{{ formatAmount(totalWorth) }}</strong>
    </div>

    <h3>Breakdown by Store</h3>

    <table class="stores-table">
      <thead>
        <tr>
          <th>Store Name</th>
          <th>Store Worth (Ksh.)</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="store in stores" :key="store.store_id">
          <td>{{ store.store_name }}</td>
          <td>{{ formatAmount(store.store_worth) }}</td>
          <td>
            <button @click="goToStore(store.store_id)">View Store</button>
          </td>
        </tr>
        <tr v-if="!stores.length">
          <td colspan="3" class="no-data">No store records available</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
export default {
  name: "InventorySummaryPage",
  data() {
    return {
      totalWorth: 0,
      stores: [],
    };
  },
  methods: {
    async fetchSummary() {
      // Dummy backend-like data
      const url = `inventoryWorthSummary`;
      const res = await generalApiRequest(url, "GET", {}, 1);

      this.stores = res.worth_by_store;
      this.totalWorth = res.total_worth;
    },

    formatAmount(value) {
      return Number(value).toLocaleString();
    },
    goToStore(storeId) {
      this.$router.push("/item_stock_details/" + storeId);
    },
  },
  mounted() {
    this.fetchSummary();
  },
};
</script>

<style scoped>
.inventory-summary-page {
  padding: 20px;
  max-width: 850px;
  margin: 0 auto;
  font-family: sans-serif;
}

.total-worth-box {
  padding: 15px;
  background: #e3f2fd;
  border-left: 5px solid #2196f3;
  font-size: 20px;
  margin-bottom: 20px;
}

.stores-table {
  width: 100%;
  border-collapse: collapse;
}

.stores-table th,
.stores-table td {
  border: 1px solid #ddd;
  padding: 8px 10px;
  font-size: 14px;
}

.stores-table th {
  background: #f0f0f0;
  text-align: left;
}

.stores-table tr:nth-child(even) {
  background: #fafafa;
}

.stores-table button {
  padding: 6px 12px;
  background: #1976d2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.stores-table button:hover {
  background: #1565c0;
}

.no-data {
  text-align: center;
  font-style: italic;
  padding: 12px;
}
</style>
